import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { defaultPagingChoices, purchaseOrder, paging, documentTypes, listTerms } from "@/js/lists.ts";
import { formatPrice } from "@/js/currency/currencies.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { filterVAutocomplete } from "@/js/forms.js";
import PurchaseOrderAttachedFilesDrawer from "@/components/purchase-orders/PurchaseOrderAttachedFilesDrawer.vue";
import Paging from "@/components/paging/PagingComponent.vue";
import Index from "@/components/paging/IndexComponent.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ImportSupplierPrices from "@/components/supplier-prices/ImportSupplierPrices.vue";
import ContextMenu from "@/components/context-menu/ContextMenu.vue";
export default {
  name: "PurchaseOrder",
  components: {
    Confirm: Confirm,
    Paging: Paging,
    Index: Index,
    PurchaseOrderAttachedFilesDrawer: PurchaseOrderAttachedFilesDrawer,
    ImportSupplierPrices: ImportSupplierPrices,
    ContextMenu: ContextMenu
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      references: [],
      suppliers: [],
      isLoading: true,
      isLoadingFiles: false,
      isStatelessDrawer: false,
      isFetchingPOFile: false,
      isFetchingSuppliers: false,
      isSavingComment: false,
      isSavingPaymentMethod: false,
      isSavingPaymentTerms: false,
      drawer: false,
      paymentStatusBeingUpdated: null,
      receiptStatusBeingUpdated: null,
      filesCancelToken: axios.CancelToken.source(),
      headers: [{
        text: "",
        value: "status",
        align: "center"
      }, {
        text: "Date",
        value: "creationDate",
        align: "center"
      }, {
        text: "Purchase Order#",
        value: "number",
        align: "center"
      }, {
        text: "Allocation",
        value: "isAllocation",
        align: "center"
      }, {
        text: "Reference#",
        value: "reference",
        align: "center"
      }, {
        text: "Supplier",
        value: "supplier",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "NbBottles",
        value: "itemsNbBottles",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Expected Delivery Date",
        value: "expectedDeliveryDate",
        align: "center"
      }, {
        text: "Received",
        value: "receiptStatus",
        align: "center"
      }, {
        text: "Paid",
        value: "paymentStatus",
        align: "center"
      }, {
        text: "Files",
        value: "files",
        align: "center"
      }],
      modalShown: false,
      items: [],
      searchCriterias: {
        paging: {
          limits: paging.DEFAULT,
          currentPage: 0,
          askedPage: 0
        },
        label: "",
        type: null,
        payment: null,
        receipt: null,
        wineId: null,
        supplierIds: [],
        referenceIds: []
      },
      numberOfPages: 0,
      purchaseOrderCount: null,
      currentItem: {
        files: []
      },
      pagingLimitsChoices: defaultPagingChoices,
      isLoadingWines: true,
      listWines: [],
      isDownloadingPoFile: false,
      attachedFilesPoId: null,
      purchaseOrder: purchaseOrder,
      purchaseOrderStatus: Object.entries(purchaseOrder.status).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value.text
        }]);
      }, []),
      purchaseOrderPaymentStatus: Object.entries(purchaseOrder.paymentStatus).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value.text
        }]);
      }, []),
      purchaseOrderReceiptStatus: Object.entries(purchaseOrder.receiptStatus).reduce(function (acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value.text
        }]);
      }, []),
      listPaymentMethods: Object.entries(purchaseOrder.paymentMethod).reduce(function (acc, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: +key,
          label: value.text
        }]);
      }, []),
      isImportSupplierPricesShown: false,
      drawerActualDeliveryDateOpened: false,
      drawerNewActualDeliveryDate: null,
      drawerBillDateOpened: false,
      drawerNewBillDate: null,
      drawerPaymentDateOpened: false,
      drawerNewPaymentDate: null,
      drawerNewPaymentMethod: null,
      drawerNewPaymentTerms: null,
      boolRenderTerms: false,
      documentTypes: documentTypes,
      isCheckingOrdersFillable: false,
      drawerOrdersFillableResponse: null,
      listTerms: listTerms
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/purchase-orders/").concat(this.currentItem.id, "/files");
    },
    isClosedPO: function isClosedPO() {
      return this.currentItem.status === purchaseOrder.status.CLOSED;
    },
    isDraftPO: function isDraftPO() {
      return this.currentItem.status === purchaseOrder.status.DRAFT;
    },
    isOpenPO: function isOpenPO() {
      return this.currentItem.status === purchaseOrder.status.OPEN;
    },
    isCancelledPO: function isCancelledPO() {
      return this.currentItem.status === purchaseOrder.status.CANCELLED;
    },
    hasReceivedItems: function hasReceivedItems() {
      return this.currentItem.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
    },
    isBilled: function isBilled() {
      return this.currentItem.paymentStatus === purchaseOrder.paymentStatus.BILLED;
    },
    isPaid: function isPaid() {
      return this.currentItem.paymentStatus === purchaseOrder.paymentStatus.PAID;
    },
    hasResult: function hasResult() {
      return !this.isLoading && this.items.length > 0;
    },
    drawerFillableHasCheck: function drawerFillableHasCheck() {
      return this.drawerOrdersFillableResponse !== null;
    },
    drawerFillableHasItems: function drawerFillableHasItems() {
      return !this.drawerFillableHasCheck ? false : this.drawerOrdersFillableResponse.hasWineFillable;
    },
    drawerFillableNbItems: function drawerFillableNbItems() {
      return !this.drawerFillableHasCheck ? false : this.drawerOrdersFillableResponse.numberOfItemsFillable;
    }
  },
  created: function created() {
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.purchaseOrders) {
      this.searchCriterias = _objectSpread(_objectSpread({}, this.searchCriterias), filters.purchaseOrders);
    }
    this.fetchWines();
    this.fetchPurchaseOrders();
    this.fetchSuppliers();
    this.fetchReferences();
  },
  methods: _defineProperty(_defineProperty(_defineProperty({
    formatPrice: formatPrice,
    fetchSuppliers: function fetchSuppliers() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _this2.isFetchingSuppliers = true;
              _context.next = 4;
              return request("/v1/suppliers", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load suppliers.", {
                  type: "error"
                });
                throw e;
              }).finally(function () {
                _this.isFetchingSuppliers = false;
              });
            case 4:
              response = _context.sent;
              _this2.suppliers = response.data.value;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchReferences: function fetchReferences() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/purchase-orders/references", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load suppliers.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this3.references = response.data.value;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.fetchPurchaseOrders();
        window.scrollTo(0, 0);
      }
    },
    changeBillDate: function changeBillDate() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!_this4.isBilled && !_this4.isPaid)) {
                _context3.next = 5;
                break;
              }
              _context3.next = 3;
              return _this4.markPayment(_this4.purchaseOrder.paymentStatus.BILLED);
            case 3:
              _context3.next = 7;
              break;
            case 5:
              _context3.next = 7;
              return _this4.updateBillDate();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changePaymentDate: function changePaymentDate() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this5.isPaid) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return _this5.markPayment(_this5.purchaseOrder.paymentStatus.PAID);
            case 3:
              _context4.next = 7;
              break;
            case 5:
              _context4.next = 7;
              return _this5.updatePaymentDate();
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    markPayment: function markPayment(value) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.paymentStatusBeingUpdated = value;
              data = {
                BillDate: _this6.drawerNewBillDate,
                PaymentDate: _this6.drawerNewPaymentDate
              };
              _this = _this6;
              _context5.next = 5;
              return request("/v1/purchase-orders/".concat(_this6.currentItem.id, "/payment-status/").concat(value), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the status.", {
                  type: "error"
                });
                _this.paymentStatusBeingUpdated = null;
                if (value == purchaseOrder.paymentStatus.BILLED) {
                  _this.drawerNewBillDate = _this6.currentItem.billDate ? new Date(_this6.currentItem.billDate).formatForDatePickerDays() : null;
                  _this.drawerBillDateOpened = false;
                } else if (value == purchaseOrder.paymentStatus.PAID) {
                  _this.drawerNewPaymentDate = _this6.currentItem.paymentDate ? new Date(_this6.currentItem.paymentDate).formatForDatePickerDays() : null;
                  _this.drawerPaymentDateOpened = false;
                }
                throw e;
              });
            case 5:
              _this6.paymentStatusBeingUpdated = null;
              _this6.currentItem.paymentStatus = value;
              if (value == purchaseOrder.paymentStatus.BILLED) {
                _this6.currentItem.billDate = data.BillDate;
                _this6.drawerBillDateOpened = false;
              } else if (value == purchaseOrder.paymentStatus.PAID) {
                _this6.currentItem.paymentDate = data.PaymentDate;
                _this6.drawerPaymentDateOpened = false;
              }
              _this6.$toasted.show("Successful update.", {
                type: "success"
              });
              _this6.fetchPurchaseOrders();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    updateBillDate: function updateBillDate() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              data = {
                Date: _this7.drawerNewBillDate
              };
              _this = _this7;
              _context6.next = 4;
              return request("/v1/purchase-orders/".concat(_this7.currentItem.id, "/bill-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the bill date.", {
                  type: "error"
                });
                _this.drawerNewBillDate = _this7.currentItem.billDate ? new Date(_this7.currentItem.billDate).formatForDatePickerDays() : null;
                _this.drawerBillDateOpened = false;
                throw e;
              });
            case 4:
              _this7.currentItem.billDate = new Date(data.Date, "YYYY-MM-DD").toLocaleDateString("en-US");
              _this7.drawerBillDateOpened = false;
              _this7.$toasted.show("Successful update.", {
                type: "success"
              });
              _this7.fetchPurchaseOrders();
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    updatePaymentDate: function updatePaymentDate() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              data = {
                Date: _this8.drawerNewPaymentDate
              };
              _this = _this8;
              _context7.next = 4;
              return request("/v1/purchase-orders/".concat(_this8.currentItem.id, "/payment-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the pyament date.", {
                  type: "error"
                });
                _this.drawerNewPaymentDate = _this8.currentItem.paymentDate ? new Date(_this8.currentItem.paymentDate).formatForDatePickerDays() : null;
                _this.drawerPaymentDateOpened = false;
                throw e;
              });
            case 4:
              _this8.currentItem.paymentDate = new Date(data.Date, "YYYY-MM-DD").toLocaleDateString("en-US");
              _this8.drawerPaymentDateOpened = false;
              _this8.$toasted.show("Successful update.", {
                type: "success"
              });
              _this8.fetchPurchaseOrders();
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    changeActualDeliveryDate: function changeActualDeliveryDate() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (_this9.hasReceivedItems) {
                _context8.next = 5;
                break;
              }
              _context8.next = 3;
              return _this9.markAsReceived();
            case 3:
              _context8.next = 7;
              break;
            case 5:
              _context8.next = 7;
              return _this9.updateActualDeliveryDate();
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    markAsReceived: function markAsReceived() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.isStatelessDrawer = true;
              _context9.next = 3;
              return _this10.$refs.confirm.open("Are you sure?", "You will not be able to change your purchase order after that.", {
                color: "red"
              });
            case 3:
              confirmed = _context9.sent;
              if (!confirmed) {
                _context9.next = 9;
                break;
              }
              _context9.next = 7;
              return _this10.markReceipt(purchaseOrder.receiptStatus.RECEIVED);
            case 7:
              _context9.next = 10;
              break;
            case 9:
              _this10.drawerNewActualDeliveryDate = _this10.currentItem.actualDeliveryDate ? new Date(_this10.currentItem.actualDeliveryDate).formatForDatePickerDays() : null;
            case 10:
              _this10.digestStatelessDrawer();
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    markReceipt: function markReceipt(value) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.receiptStatusBeingUpdated = value;
              data = {
                ActualDeliveryDate: _this11.drawerNewActualDeliveryDate
              };
              _this = _this11;
              _context10.next = 5;
              return request("/v1/purchase-orders/".concat(_this11.currentItem.id, "/receipt-status/").concat(value), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the status.", {
                  type: "error"
                });
                _this.receiptStatusBeingUpdated = null;
                _this.drawerNewActualDeliveryDate = _this.currentItem.actualDeliveryDate ? new Date(_this.currentItem.actualDeliveryDate).formatForDatePickerDays() : null;
                _this.drawerActualDeliveryDateOpened = false;
                _this.digestStatelessDrawer();
                throw e;
              });
            case 5:
              _this11.receiptStatusBeingUpdated = null;
              _this11.currentItem.receiptStatus = value;
              _this11.currentItem.actualDeliveryDate = new Date(data.ActualDeliveryDate, "YYYY-MM-DD").toLocaleDateString("en-US");
              _this11.drawerActualDeliveryDateOpened = false;
              _this11.$toasted.show("Successful update.", {
                type: "success"
              });
              _context10.next = 12;
              return _this11.fetchPurchaseOrders();
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    updateActualDeliveryDate: function updateActualDeliveryDate() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              data = {
                Date: _this12.drawerNewActualDeliveryDate
              };
              _this = _this12;
              _context11.next = 4;
              return request("/v1/purchase-orders/".concat(_this12.currentItem.id, "/actual-delivery-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the date.", {
                  type: "error"
                });
                _this.drawerNewActualDeliveryDate = _this.currentItem.actualDeliveryDate ? new Date(_this.currentItem.actualDeliveryDate).formatForDatePickerDays() : null;
                _this.drawerActualDeliveryDateOpened = false;
                _this.digestStatelessDrawer();
                throw e;
              });
            case 4:
              _this12.currentItem.actualDeliveryDate = new Date(data.Date, "YYYY-MM-DD").toLocaleDateString("en-US");
              _this12.drawerActualDeliveryDateOpened = false;
              _this12.$toasted.show("Successful update.", {
                type: "success"
              });
              _context11.next = 9;
              return _this12.fetchPurchaseOrders();
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    selectItem: function selectItem(value) {
      this.currentItem = _objectSpread(_objectSpread({}, value), {}, {
        files: []
      });
      this.drawerNewActualDeliveryDate = this.currentItem.actualDeliveryDate ? new Date(this.currentItem.actualDeliveryDate).formatForDatePickerDays() : null;
      this.drawerNewBillDate = this.currentItem.billDate ? new Date(this.currentItem.billDate).formatForDatePickerDays() : null;
      this.drawerNewPaymentDate = this.currentItem.paymentDate ? new Date(this.currentItem.paymentDate).formatForDatePickerDays() : null;
      this.drawerOrdersFillableResponse = null;
      this.drawerNewPaymentMethod = this.currentItem.paymentMethod;
      this.drawerNewPaymentTerms = this.currentItem.terms;
      this.drawer = !this.drawer;
    },
    getToEditPurchaseOrder: function getToEditPurchaseOrder(value) {
      this.$router.push({
        name: "adminEditPurchaseOrder",
        params: {
          id: value.id
        }
      });
    },
    search: function search() {
      var _this13 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          purchaseOrders: _this13.searchCriterias
        });
      });
      if (isResetPaging) this.resetPaging();
      this.fetchPurchaseOrders();
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    fetchWines: function fetchWines() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return request("/v1/wines", "post", {
                paging: null,
                calculate_prices: false,
                only_display_names: true,
                bypassStockSeek: true,
                byPassPagingLimitation: true
              }, true, "api").catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                return;
              });
            case 2:
              response = _context12.sent;
              _this14.listWines = response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              });
              _this14.isLoadingWines = false;
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    fetchPurchaseOrders: function fetchPurchaseOrders() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this15;
              _this.isLoading = true;
              _this15.$EventBus.$emit("loading", true);
              _context13.next = 5;
              return request("/v1/purchase-orders/all", "post", _this15.searchCriterias, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current purchase orders.", {
                  type: "error"
                });
                _this.isLoading = false;
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 5:
              response = _context13.sent;
              _this15.purchaseOrderCount = response.data.value.total_number;
              _this15.numberOfPages = Math.ceil(_this15.purchaseOrderCount / +_this15.searchCriterias.paging.limits);
              _this15.searchCriterias.paging.currentPage = _this15.searchCriterias.paging.askedPage + 1;
              _this15.items = response.data.value.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  supplier: x.supplierName
                });
              });
              _this15.isLoading = false;
              _this15.$EventBus.$emit("loading", false);
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    fetchPurchaseOrderFiles: function fetchPurchaseOrderFiles() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this = _this16;
              _this16.isLoadingFiles = true;
              _context14.next = 4;
              return request("/v1/purchase-orders/".concat(_this16.currentItem.id, "/files"), "get", null, true, "api", null, _this16.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.isLoadingFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context14.sent;
              if (response) _this16.currentItem.files = _toConsumableArray(response.data);
              _this16.isLoadingFiles = false;
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    goToNewPurchaseOrder: function goToNewPurchaseOrder() {
      this.$router.push({
        name: "adminNewPurchaseOrder"
      });
    },
    importSupplierPrices: function importSupplierPrices() {
      this.isImportSupplierPricesShown = true;
    },
    rowClickContextMenu: function rowClickContextMenu(mouseEvent, event) {
      mouseEvent.preventDefault();
      var contextItems = [{
        type: "routerLinkBlank",
        text: "Open in a new tab",
        class: "router-link --no-hover-underlined",
        routeData: {
          name: "adminEditPurchaseOrder",
          params: {
            id: event.item.id
          }
        }
      }];
      var position = {
        x: mouseEvent.x,
        y: mouseEvent.y
      };
      this.$refs.contextMenu.openMenu(event.item, contextItems, position);
    },
    downloadPoFile: function downloadPoFile(poId) {
      var _this = this;
      _this.isDownloadingPoFile = true;
      request("/v1/purchase-orders/".concat(poId, "/files/po"), "get", null, true, "api", null).then(function (response) {
        _this.openUrl(response.data.url);
      }).catch(function (e) {
        _this.$toasted.show("Unable to download file.", {
          type: "error"
        });
      }).finally(function () {
        _this.isDownloadingPoFile = false;
      });
    }
  }, "openUrl", function openUrl(url) {
    window.open(url, "_blank");
  }), "openAttachedFilesDrawer", function openAttachedFilesDrawer(poId) {
    var _this17 = this;
    this.attachedFilesPoId = poId;
    this.$nextTick(function () {
      _this17.$refs.PurchaseOrderAttachedFilesDrawer.openDrawer();
    });
  }), "filterVAutocomplete", filterVAutocomplete)
};